export default function AccessInfo() {
  const steps = [
    {
      number: '01',
      title: 'JR逗子駅から徒歩でお越しの場合（徒歩約11分）',
      directions: [
        'JR横須賀線「逗子駅」東口を出て、駅前ロータリーを右手に進みます',
        '国道134号線(逗子海岸通り)を海の方向へ直進してください',
        '約850m直進すると、左手に「ミハルアート逗子海岸」という建物が見えてきます',
        '建物の入口から階段で2階へお上がりください。202号室が当事業所です'
      ],
      image: 'https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/ccfbd5c2408d64684240a52f6d87a248.jpeg'
    },
    {
      number: '02',
      title: '京急逗子・葉山駅から徒歩でお越しの場合（徒歩約3分）',
      directions: [
        '京急逗子線「逗子・葉山駅」改札を出て、JR逗子駅方面へ向かいます',
        'JR逗子駅東口に到着したら、国道134号線を海の方向へ進んでください',
        '約200m直進すると、左手に「ミハルアート逗子海岸」という建物が見えてきます',
        '建物の入口から階段で2階へお上がりください。202号室が当事業所です'
      ],
      image: 'https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/233909816e27ec2e0a4613d3868a4575.jpeg'
    },
    {
      number: '03',
      title: '目印となる建物',
      directions: [
        '国道134号線沿いの「ミハルアート逗子海岸」という建物です',
        '1階には店舗が入っており、建物の入口から階段で2階へお上がりください',
        '202号室のドアに「まごころヘルパー」の表札がございます'
      ],
      image: 'https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/72d2aaebb48723b63609b0fc02eb2e45.jpeg',
      imagePosition: 'center 35%'
    }
  ];

  return (
    <section className="py-24 bg-gray-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12 text-center">
          アクセス
        </h2>

        <div className="max-w-6xl mx-auto mb-16">
          <div className="h-[500px] rounded-3xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3256.4577214503224!2d139.57633632714894!3d35.29460660111327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601846ee335c25fb%3A0xc8343efd056aad01!2z44CSMjQ5LTAwMDYg56We5aWI5bed55yM6YCX5a2Q5biC6YCX5a2Q77yV5LiB55uu77yR77yR4oiS77yX!5e0!3m2!1sja!2sjp!4v1768455231614!5m2!1sja!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="まごころヘルパーの地図"
            ></iframe>
          </div>
        </div>

        <div className="space-y-16 max-w-6xl mx-auto mb-16">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-3xl shadow-lg overflow-hidden">
              <div className="grid lg:grid-cols-5 gap-8 p-10">
                <div className="lg:col-span-3 space-y-6">
                  <div className="flex items-center gap-4">
                    <div className="w-16 h-16 bg-cyan-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl font-bold text-white">{step.number}</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      {step.title}
                    </h3>
                  </div>
                  <ol className="space-y-3">
                    {step.directions.map((direction, idx) => (
                      <li key={idx} className="flex gap-3 text-lg text-gray-700">
                        <span className="font-bold text-cyan-600 flex-shrink-0">{idx + 1}.</span>
                        <span className="leading-relaxed">{direction}</span>
                      </li>
                    ))}
                  </ol>
                </div>

                <div className="lg:col-span-2">
                  <div className="h-[280px] rounded-2xl overflow-hidden shadow-md">
                    <img
                      src={step.image}
                      alt={step.title}
                      className="w-full h-full object-cover"
                      style={step.imagePosition ? { objectPosition: step.imagePosition } : undefined}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          <div className="bg-cyan-50 rounded-3xl p-10">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-parking-box-line text-cyan-600 text-3xl"></i>
              駐車場について
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              専用駐車場はございませんので、お車でお越しの際は近隣のコインパーキングをご利用ください。逗子駅周辺に複数のコインパーキングがございます。
            </p>
          </div>

          <div className="bg-blue-50 rounded-3xl p-10">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-bus-line text-blue-600 text-3xl"></i>
              バスをご利用の場合
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              逗子駅からバスをご利用の場合は、「逗子海岸」行きのバスに乗車し、「逗子海岸」バス停で下車してください。バス停から徒歩約2分です。
            </p>
          </div>

          <div className="bg-amber-50 rounded-3xl p-10">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-information-line text-amber-600 text-3xl"></i>
              ご来訪の際の注意点
            </h3>
            <ul className="space-y-3 text-lg text-gray-700">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line text-amber-600 text-2xl flex-shrink-0"></i>
                <span>初めてお越しの方は、建物が分かりにくい場合がございますので、お気軽にお電話ください。</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line text-amber-600 text-2xl flex-shrink-0"></i>
                <span>事前にご連絡いただければ、スタッフが建物の入口までご案内いたします。</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line text-amber-600 text-2xl flex-shrink-0"></i>
                <span>見学や面接の際は、事前にご予約をお願いいたします。</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
